// extracted by mini-css-extract-plugin
var _1 = "BirdviewChartCatalogEmpty-moduleempty__UDUA7";
export { _1 as "empty" }
